import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/workspace/src/layouts/index.js";
import Button from '../components/button';
import BG from '../components/bg';
import styled from 'styled-components';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Title = makeShortcode("Title");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <BG mdxType="BG" />
    <div style={{
      maxWidth: '650px',
      margin: '0px auto',
      padding: '0 1rem'
    }}>
      <Title mdxType="Title">Starswap V3 Bug Bounty</Title>
      <center>
  <Button href="mailto:security@starswap.xyz" mdxType="Button">
    Submit a report
  </Button>
      </center>
      <br />
      <br />
      <h1 {...{
        "id": "overview",
        "style": {
          "position": "relative"
        }
      }}><a parentName="h1" {...{
          "href": "#overview",
          "aria-label": "overview permalink",
          "className": "anchor before"
        }}><svg parentName="a" {...{
            "aria-hidden": "true",
            "focusable": "false",
            "height": "16",
            "version": "1.1",
            "viewBox": "0 0 16 16",
            "width": "16"
          }}><path parentName="svg" {...{
              "fillRule": "evenodd",
              "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
            }}></path></svg></a>{`Overview`}</h1>
      <p>{`Today, we are announcing an official Starswap v3 Bug Bounty (the `}{`”`}{`Program`}{`”`}{`) to incentivize responsible bug disclosure.`}</p>
      <p>{`We are limiting the scope of the Program to critical and high severity bugs in the core contracts and are offering a reward of up to $500,000. Happy hunting!`}</p>
      <h1 {...{
        "id": "scope",
        "style": {
          "position": "relative"
        }
      }}><a parentName="h1" {...{
          "href": "#scope",
          "aria-label": "scope permalink",
          "className": "anchor before"
        }}><svg parentName="a" {...{
            "aria-hidden": "true",
            "focusable": "false",
            "height": "16",
            "version": "1.1",
            "viewBox": "0 0 16 16",
            "width": "16"
          }}><path parentName="svg" {...{
              "fillRule": "evenodd",
              "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
            }}></path></svg></a>{`Scope`}</h1>
      <p>{`The scope of the Program will initially be limited to high severity bugs in Starswap`}{`’`}{`s core contracts. Any bug found that would result in draining reserve funds is considered in scope.`}</p>
      <p>{`The following are not within the scope of the Program:`}</p>
      <ul>
        <li parentName="ul">{`The example contracts and the contracts in the test folder for the Periphery Contracts link set forth above;`}</li>
        <li parentName="ul">{`Any contract removed from the list of contracts in the Periphery Contracts link set forth above (such list may change from time to time without notice);`}</li>
        <li parentName="ul">{`Bugs in any third party contract or platform that interacts with Starswap V3;`}</li>
        <li parentName="ul">{`Vulnerabilities already reported and/or discovered in contracts built by third parties on Starswap V3; and`}</li>
        <li parentName="ul">{`Any already-reported bugs.`}</li>
      </ul>
      <p>{`Vulnerabilities contingent upon the occurrence of any of the following also are outside the scope of this Program:`}</p>
      <ul>
        <li parentName="ul">{`Front end bugs;`}</li>
        <li parentName="ul">{`DDOS attacks;`}</li>
        <li parentName="ul">{`Spamming;`}</li>
        <li parentName="ul">{`Phishing;`}</li>
        <li parentName="ul">{`Automated tools (github actions, aws); and`}</li>
        <li parentName="ul">{`Compromise or misuse of third party systems or services.`}</li>
      </ul>
      <h1 {...{
        "id": "assumptions",
        "style": {
          "position": "relative"
        }
      }}><a parentName="h1" {...{
          "href": "#assumptions",
          "aria-label": "assumptions permalink",
          "className": "anchor before"
        }}><svg parentName="a" {...{
            "aria-hidden": "true",
            "focusable": "false",
            "height": "16",
            "version": "1.1",
            "viewBox": "0 0 16 16",
            "width": "16"
          }}><path parentName="svg" {...{
              "fillRule": "evenodd",
              "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
            }}></path></svg></a>{`Assumptions`}</h1>
      <p>{`Starswap V3 was developed with the following assumptions, and thus any bug must also adhere to the following assumptions to be eligible for the bug bounty:`}</p>
      <ul>
        <li parentName="ul">{`The total supply of any token does not exceed 2128 - 1, i.e. type(uint128).max.`}</li>
        <li parentName="ul">{`The transfer and transferFrom methods of any token strictly decrease the balance of the token sender by the transfer amount and increases the balance of token recipient by the transfer amount, i.e. fee on transfer tokens are excluded.`}</li>
        <li parentName="ul">{`The token balance of an address can only change due to a call to transfer by the sender or transferFrom by an approved address, i.e. rebase tokens and interest bearing tokens are excluded.`}</li>
      </ul>
      <h1 {...{
        "id": "rewards",
        "style": {
          "position": "relative"
        }
      }}><a parentName="h1" {...{
          "href": "#rewards",
          "aria-label": "rewards permalink",
          "className": "anchor before"
        }}><svg parentName="a" {...{
            "aria-hidden": "true",
            "focusable": "false",
            "height": "16",
            "version": "1.1",
            "viewBox": "0 0 16 16",
            "width": "16"
          }}><path parentName="svg" {...{
              "fillRule": "evenodd",
              "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
            }}></path></svg></a>{`Rewards`}</h1>
      <p>{`Rewards will be allocated based on the severity of the bug disclosed and will be evaluated and rewarded at the discretion of the Starswap Labs team. For critical bugs that lead to any loss of LP funds, rewards of up to $500,000 will be granted. Lower severity bugs will be rewarded at the discretion of the team. In addition, all vulnerabilities disclosed prior to the target mainnet launch date, May 5 will be subject to receive higher rewards.`}</p>
      <h1 {...{
        "id": "disclosure",
        "style": {
          "position": "relative"
        }
      }}><a parentName="h1" {...{
          "href": "#disclosure",
          "aria-label": "disclosure permalink",
          "className": "anchor before"
        }}><svg parentName="a" {...{
            "aria-hidden": "true",
            "focusable": "false",
            "height": "16",
            "version": "1.1",
            "viewBox": "0 0 16 16",
            "width": "16"
          }}><path parentName="svg" {...{
              "fillRule": "evenodd",
              "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
            }}></path></svg></a>{`Disclosure`}</h1>
      <p>{`Any vulnerability or bug discovered must be reported only to the following email: `}<a parentName="p" {...{
          "href": "mailto:contact@starswap.xyz"
        }}>{`security@starswap.xyz`}</a>{`.`}</p>
      <p>{`The vulnerability must not be disclosed publicly or to any other person, entity or email address before Starswap Labs has been notified, has fixed the issue, and has granted permission for public disclosure. In addition, disclosure must be made within 24 hours following discovery of the vulnerability.`}</p>
      <p>{`A detailed report of a vulnerability increases the likelihood of a reward and may increase the reward amount. Please provide as much information about the vulnerability as possible, including:`}</p>
      <ul>
        <li parentName="ul">{`The conditions on which reproducing the bug is contingent.`}</li>
        <li parentName="ul">{`The steps needed to reproduce the bug or, preferably, a proof of concept.`}</li>
        <li parentName="ul">{`The potential implications of the vulnerability being abused.`}</li>
      </ul>
      <p>{`Anyone who reports a unique, previously-unreported vulnerability that results in a change to the code or a configuration change and who keeps such vulnerability confidential until it has been resolved by our engineers will be recognized publicly for their contribution if they so choose.`}</p>
      <h1 {...{
        "id": "eligibility",
        "style": {
          "position": "relative"
        }
      }}><a parentName="h1" {...{
          "href": "#eligibility",
          "aria-label": "eligibility permalink",
          "className": "anchor before"
        }}><svg parentName="a" {...{
            "aria-hidden": "true",
            "focusable": "false",
            "height": "16",
            "version": "1.1",
            "viewBox": "0 0 16 16",
            "width": "16"
          }}><path parentName="svg" {...{
              "fillRule": "evenodd",
              "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
            }}></path></svg></a>{`Eligibility`}</h1>
      <p>{`To be eligible for a reward under this Program, you must:`}</p>
      <ul>
        <li parentName="ul">
          <p parentName="li">{`Discover a previously unreported, non-public vulnerability that would result in a loss of and/or lock on any ERC-20 token on Starswap V3 (but not on any third party platform interacting with Starswap V3) and that is within the scope of this Program.`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Be the first to disclose the unique vulnerability to `}<a parentName="p" {...{
              "href": "mailto:security@starswap.xyz"
            }}>{`security@starswap.xyz`}</a>{`, in compliance with the disclosure requirements above. If similar vulnerabilities are reported within the same 24 hour period, rewards will be split at the discretion of Starswap Labs.`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Provide sufficient information to enable our engineers to reproduce and fix the vulnerability.`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Not engage in any unlawful conduct when disclosing the bug to `}<a parentName="p" {...{
              "href": "mailto:security@starswap.xyz"
            }}>{`security@starswap.xyz`}</a>{`, including through threats, demands, or any other coercive tactics.`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Not exploit the vulnerability in any way, including through making it public or by obtaining a profit (other than a reward under this Program).`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Make a good faith effort to avoid privacy violations, destruction of data, interruption or degradation of Starswap V3.`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Submit only one vulnerability per submission, unless you need to chain vulnerabilities to provide impact regarding any of the vulnerabilities.`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Not submit a vulnerability caused by an underlying issue that is the same as an issue on which a reward has been paid under this Program.`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Be at least 18 years of age or, if younger, submit your vulnerability with the consent of your parent or guardian.`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Not be subject to US sanctions or reside in a US-embargoed country.`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Not be one of our current or former employees, vendors, or contractors or an employee of any of those vendors or contractors.`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Comply with all the eligibility requirements of the Program.`}</p>
        </li>
      </ul>
      <h1 {...{
        "id": "other-terms",
        "style": {
          "position": "relative"
        }
      }}><a parentName="h1" {...{
          "href": "#other-terms",
          "aria-label": "other terms permalink",
          "className": "anchor before"
        }}><svg parentName="a" {...{
            "aria-hidden": "true",
            "focusable": "false",
            "height": "16",
            "version": "1.1",
            "viewBox": "0 0 16 16",
            "width": "16"
          }}><path parentName="svg" {...{
              "fillRule": "evenodd",
              "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
            }}></path></svg></a>{`Other Terms`}</h1>
      <p>{`By submitting your report, you grant Starswap Labs any and all rights, including intellectual property rights, needed to validate, mitigate, and disclose the vulnerability. All reward decisions, including eligibility for and amounts of the rewards and the manner in which such rewards will be paid, are made at our sole discretion.`}</p>
      <p>{`The terms and conditions of this Program may be altered at any time.`}</p>
      <br />
      <br />
      <br />
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      